import React from 'react';
import { Card } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

export default function HomeCard ({
  image,
  title,
  text,
  route,
}) {
  const history = useHistory();
  function handleClick () {
    history.push(route);
  }
  return (
    <Card onClick={handleClick} className="home-card" style={{ cursor: 'pointer', width: '18rem', height: '25rem' }}>
      <img style={{ borderRadius: '3px' }} alt="img" height="280px" src={image} />
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text>
          {text}
        </Card.Text>
      </Card.Body>
    </Card>
  );
}
